import { useDispatch } from 'react-redux';
import { clearUpdateNewsletters } from '@client/myAccount/newsletters/redux/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useClearUpdateNewslettersAction = (): typeof clearUpdateNewsletters => {
  const dispatch = useDispatch();

  return bindActionCreators(clearUpdateNewsletters, dispatch);
};
